import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import SessionConnector, { ConnectorProps as SessionProps } from '../connectors/Session'

type Props = SessionProps & {
  shouldLoadComponent: boolean
  setShouldLoadComponent: (...args: Array<any>) => any
}
const RecommendedCarousel = dynamic(
  import(
    /* webpackChunkName: "RecommendedCarouselPLP" */
    '../../../saatchi/artdetail2/components/Carousels/GoogleRecommended/plp'
  ),
  noSSR
)

const GoogleRecommendedCarousel: FC<Props> = (props) => {
  const { isAuthenticated, shouldLoadComponent, setShouldLoadComponent } = props

  if (!isAuthenticated) {
    return null
  }

  return (
    <RecommendedCarousel
      shouldLoadComponent={shouldLoadComponent}
      setShouldLoadComponent={setShouldLoadComponent}
    />
  )
}

export default SessionConnector(GoogleRecommendedCarousel)
